import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useLayoutPreferences, PATIENT_DETAIL_LAYOUT_LABELS, type PatientDetailLayout } from '@/hooks/useLayoutPreferences';
import { IconButton } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function GeneralSettings() {
  useDocumentTitle('Settings — General');
  const navigate = useNavigate();
  const { patientDetailLayout, setPatientDetailLayout } = useLayoutPreferences();

  const handleLayoutChange = (value: string) => {
    setPatientDetailLayout(value as PatientDetailLayout);
  };

  return (
    <div className="flex h-full min-h-0 flex-col gap-4 overflow-auto p-1">
      <div className="flex items-center gap-3">
        <IconButton variant="ghost-light" size="icon" icon={ArrowLeft} aria-label="Back" onClick={() => navigate('/patients')} />
        <div>
          <h1 className="text-lg font-semibold text-white/90">General settings</h1>
          <p className="text-xs text-white/45">Workspace layout and display preferences</p>
        </div>
      </div>

      <section className="surface-panel max-w-lg p-5">
        <h2 className="text-sm font-semibold text-white/85">Patient overview</h2>
        <p className="mt-1 text-xs text-white/45">Choose how patient details appear when you select a row.</p>

        <div className="mt-4 space-y-2">
          <label htmlFor="patient-detail-layout" className="text-[10px] font-semibold uppercase tracking-[0.14em] text-white/40">
            Layout mode
          </label>
          <Select value={patientDetailLayout} onValueChange={handleLayoutChange}>
            <SelectTrigger id="patient-detail-layout" className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {(Object.keys(PATIENT_DETAIL_LAYOUT_LABELS) as PatientDetailLayout[]).map((key) => (
                <SelectItem key={key} value={key}>
                  {PATIENT_DETAIL_LAYOUT_LABELS[key].title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-white/50">{PATIENT_DETAIL_LAYOUT_LABELS[patientDetailLayout].description}</p>
        </div>

        <p className="mt-4 text-[10px] text-white/35">Saved locally in this browser.</p>
      </section>
    </div>
  );
}
